<template lang="pug">
.base-field
  v-list-tile
    .body-2 {{ label }}：
    .body-1 {{ value }}
</template>
<script>
export default {
  name: "BaseField",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    }
  }
};
</script>
